import React, { createContext, useContext } from "react";

interface VideoContext {
    videoId?: string;
    isLoading: boolean;
    isError: boolean;
}

const VideoContext = createContext<VideoContext | undefined>(undefined);

export interface VideoProviderProps {
    videoId?: string;
    isLoading: boolean;
    isError: boolean;
    children: React.ReactNode;
}

export const VideoProvider: React.FC<VideoProviderProps> = ({
    videoId,
    isLoading,
    isError,
    children,
}) => {
    const value = React.useMemo(
        () => ({ videoId, isLoading, isError }),
        [videoId, isLoading, isError],
    );

    return (
        <VideoContext.Provider value={value}>{children}</VideoContext.Provider>
    );
};

export function useVideoContext(): VideoContext {
    const ctx = useContext(VideoContext);
    if (!ctx) {
        throw new Error("useVideoContext must be used within a VideoProvider");
    }
    return ctx;
}
